<template>
  <div class="mod-account-access">
    <div class="title-page">
      <span class="text-title">账号授权</span>
      <a 
        v-if="isNew === false"
        class="item-btn"
        @click="add"
      >
        + 新增授权账户
      </a>
    </div>
    <ShowForm
      :formData="filterData" 
      :inline="true" 
      type="filter"
      @change="changeHandle"
      @submit="doSearch"
    />
    <ShowTable 
      :listData="listData" 
      :pageSize="params.page_size"
      @linkClick="linkClickHandle" 
      @actionClick="actionClickHandle"
      @pageChange="pageChangeHandle"
      @pageSizeChange="pageSizeChangeHandle"
    />
    <el-dialog 
      :visible.sync="addDialogShow"
      title="新增授权" 
      width="620px"
      top="60px"
      :modal="false"
      :show-close="false"
      custom-class="dialog-right"
    >
      <div class="add-content-box">
        <ShowForm
          ref="form"
          :formData="addFormData"
          :commitShow="false"
          label-width="130px"
          input-width="460px"
          @action="actionClick"
          @change="formChange"
        />
        <div
          v-if="isSubAgentAuthType"
          class="sub-agent-auth-box"
        >
          <div class="sub-agent-form-row">
            <label class="sub-agent-label is-required">授权账户：</label>
            <div class="sub-agent-field">
              <div class="sub-agent-check-row">
                <el-input
                  v-model="subAgentAuth.sub_agent_id"
                  placeholder="请输入子管理账号ID"
                  @input="resetSubAgentVerify"
                  @keyup.enter.native="verifySubAgent"
                />
                <el-button
                  :loading="subAgentVerifyLoading"
                  @click="verifySubAgent"
                >
                  校验
                </el-button>
              </div>
              <div
                v-if="subAgentAuth.verifyStatus"
                class="sub-agent-verify-info"
              >
                <div
                  v-if="isSubAgentVerified"
                  class="sub-agent-name"
                >
                  {{ subAgentDisplayName }}（{{ subAgentVerifiedId }}）
                </div>
                <div class="sub-agent-status-row">
                  <span
                    :class="{
                      'sub-agent-status-tag': true,
                      success: isSubAgentVerified,
                      fail: !isSubAgentVerified
                    }"
                  >
                    {{ isSubAgentVerified ? '校验成功' : '校验失败' }}
                  </span>
                  <span
                    v-if="isSubAgentVerified"
                    class="sub-agent-budget-tip"
                  >
                    同一聚合预算
                  </span>
                  <span
                    v-if="!isSubAgentVerified && subAgentAuth.verifyMessage"
                    class="sub-agent-fail-tip"
                  >
                    {{ subAgentAuth.verifyMessage }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="sub-agent-form-row token-mode-row">
            <label class="sub-agent-label is-required">Token使用方式：</label>
            <div class="token-mode-field">
              <el-radio-group
                v-model="subAgentAuth.token_mode"
                class="token-mode-group"
                @change="onTokenModeChange"
              >
                <div
                  :class="{
                    'token-mode-option': true,
                    active: Number(subAgentAuth.token_mode) === tokenModeReuse,
                    disabled: !isSubAgentVerified
                  }"
                  @click="setTokenMode(tokenModeReuse)"
                >
                  <el-radio
                    :label="tokenModeReuse"
                    :disabled="!isSubAgentVerified"
                  >
                    <span />
                  </el-radio>
                  <div class="token-mode-content">
                    <div class="token-mode-title">复用已有Token</div>
                    <div class="token-mode-desc">选择已有子代理的Token，共享给本次授权账户。</div>
                    <div
                      v-if="Number(subAgentAuth.token_mode) === tokenModeReuse"
                      class="reuse-token-row"
                      @click.stop
                    >
                      <label class="reuse-token-label">请选择复用的Token</label>
                      <el-select
                        v-model="subAgentAuth.group_id"
                        class="reuse-token-select"
                        placeholder="请选择复用的Token"
                        filterable
                      >
                        <el-option
                          v-for="option in subAgentGroupOptions"
                          :key="option.key"
                          :label="option.name"
                          :value="option.key"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div
                  :class="{
                    'token-mode-option': true,
                    active: Number(subAgentAuth.token_mode) === tokenModeCreate,
                    disabled: !isSubAgentVerified
                  }"
                  @click="setTokenMode(tokenModeCreate)"
                >
                  <el-radio
                    :label="tokenModeCreate"
                    :disabled="!isSubAgentVerified"
                  >
                    <span />
                  </el-radio>
                  <div class="token-mode-content">
                    <div class="token-mode-title">创建独立Token</div>
                    <div class="token-mode-desc">为本次授权账户生成新的Token。</div>
                  </div>
                </div>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div 
          v-if="!isSubAgentAuthType && ((accounts && accounts.length) || noAccountText)"
          class="account-box"
        >
          <label class="form-label">账户信息：</label>
          <ul 
            v-if="accounts && accounts.length"  
            class="account-items"
          >
            <li 
              v-for="item in accounts" 
              :key="item.key"
              class="account-item"
            >
              <div class="account-title">{{ accountConfig.title.label }}：{{ item[accountConfig.title.key] }}</div>
              <div class="account-info">
                <div 
                  v-for="c in accountConfig.info"
                  :key="c.key"
                >
                  {{ c.label }}：{{ item[c.key] }}
                </div>
              </div>
            </li>
          </ul>
          <div 
            v-else
            class="no-account-text"
          >
            {{ noAccountText }}
          </div>
        </div>
      </div>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="addDialogShow = false">取 消</el-button>
        <el-button 
          type="primary" 
          :loading="addSubmitLoading"
          :disabled="subAgentSubmitDisabled"
          @click="doAdd"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog 
      :visible.sync="infoDialogShow"
      :title="'账号ID：' + curItem.target_id" 
      width="538px"
      top="60px"
      :modal="false"
      :show-close="false"
      custom-class="dialog-right"
    >
      <ul class="app-items">
        <li class="app-item">
          <label class="app-label">应用ID：</label>
          <span class="app-value">{{ curItem.app_id }}</span>
        </li>
        <li
          v-if="false" 
          class="app-item"
        >
          <label class="app-label">应用秘钥：</label>
          <span class="app-value">{{ secretShow ? curItem.app_secret : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="secretShow=!secretShow"
          >
            {{ secretShow ? '隐藏' : '查看' }}
          </a>
        </li>
        <li class="app-item">
          <label class="app-label">Access Token：<br><span class="app-label-tip">(到期时间：{{ curItem.access_token_expire }})</span></label>
          <span class="app-value">{{ accessShow ? curItem.access_token : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="accessShow=!accessShow"
          >
            {{ accessShow ? '隐藏' : '查看' }}
          </a>
        </li>
        <li class="app-item">
          <label class="app-label">Refresh Token：<br><span class="app-label-tip">({{ curItem.refresh_token_expire }})</span></label>
          <span class="app-value">{{ refreshShow ? curItem.refresh_token : pwdString }}</span>
          <a 
            class="btn-item" 
            @click="refreshShow=!refreshShow"
          >
            {{ refreshShow ? '隐藏' : '查看' }}
          </a>
        </li>
      </ul>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="infoDialogShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog 
      :visible.sync="cancelDialogShow"
      title="提示"
      width="520px"
      custom-class="dialog-confirm"
    >
      <div class="confirm-content">确认取消授权?</div>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button 
          type="primary" 
          @click="cancelAuth"
        >
          确 定
        </el-button>
        <el-button @click="cancelDialogShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ShowForm from '@/components/ShowForm/index';
import ShowTable from '@/components/ShowTable/index';
import { formatMap } from '@/assets/js/lib';
import {
  getUserInfo,
  getEnum,
  getAuthList,
  getAppList,
  getAccountList,
  verifySubAgentAuth,
  applyAuth,
  cancelAuth,
} from '@/service';

const SUB_AGENT_AUTH_TYPE = 6;
const TOKEN_MODE_REUSE = 1;
const TOKEN_MODE_CREATE = 2;

export default {
  components: {
    ShowForm,
    ShowTable,
  },
  data() {
    return {
      isNew: null,
      filterData: [],
      params: {
        page: 1,
        page_size: 20,
      },
      listData: {
        head: [
          {
            key: 'app_id',
            name: '应用ID',
            fixed: 'left',
            width: '160px',
          },
          {
            key: 'app_name',
            name: '应用名称',
          },
          {
            key: 'auth_type_desc',
            name: '账号类型',
          },
          {
            key: 'target_id',
            name: '账号ID',
            type: 'link',
            disabledKey: 'target_id_disabled',
          },
          {
            key: 'target_name',
            name: '账号名称',
          },
          {
            key: 'apply_time',
            name: '申请时间',
            width: '170px',
          },
          {
            key: 'accept_time',
            name: '授权时间',
            width: '170px',
          },
          {
            key: 'status_desc',
            name: '授权状态',
          },
          {
            key: 'verify_url',
            name: '授权链接',
            type: 'link',
            btnText: '复制链接',
          },
          {
            key: 'action',
            name: '操作',
            type: 'action',
          },
        ],
      },
      addDialogShow: false,
      accountType: [],
      formData: [],
      accountList: [],
      accounts: [],
      accountConfig: {},
      noAccountText: '',
      infoDialogShow: false,
      curItem: {},
      secretShow: false,
      accessShow: false,
      refreshShow: false,
      pwdString: '************************************************',
      cancelDialogShow: false,
      addSubmitLoading: false,
      tokenModeReuse: TOKEN_MODE_REUSE,
      tokenModeCreate: TOKEN_MODE_CREATE,
      subAgentVerifyLoading: false,
      subAgentAuth: {
        sub_agent_id: '',
        token_mode: '',
        group_id: '',
        verifyStatus: '',
        verifyMessage: '',
        detail: {},
      },
    };
  },
  computed: {
    addFormData() {
      // 子管理账号授权使用独立校验和 Token 使用方式，原授权账户选择不适用。
      if (this.isSubAgentAuthType) {
        return this.formData.filter((item) => item.key !== 'auth_ids');
      }
      return this.formData;
    },
    isSubAgentAuthType() {
      return Number(this.getFormItemValue('auth_type')) === SUB_AGENT_AUTH_TYPE;
    },
    isSubAgentVerified() {
      return this.subAgentAuth.verifyStatus === 'success';
    },
    subAgentDisplayName() {
      const detail = this.subAgentAuth.detail || {};
      return detail.sub_agent_name || '--';
    },
    subAgentVerifiedId() {
      const detail = this.subAgentAuth.detail || {};
      return detail.sub_agent_id || this.subAgentAuth.sub_agent_id;
    },
    subAgentGroupOptions() {
      const detail = this.subAgentAuth.detail || {};
      const groups = detail.groups || [];
      return groups.map((item) => {
        const name = item.sub_agent_name || item.group_id;
        const accessToken = item.access_token || '';
        const tokenText = accessToken.length > 15
          ? `${accessToken.slice(0, 15)}...`
          : accessToken;
        return {
          key: item.group_id,
          name: `${name} | ${tokenText}`,
        };
      });
    },
    hasSelectedReuseGroup() {
      const groupId = this.subAgentAuth.group_id;
      return groupId !== '' && groupId !== undefined && groupId !== null;
    },
    subAgentSubmitDisabled() {
      if (!this.isSubAgentAuthType) return false;
      if (this.subAgentVerifyLoading || !this.isSubAgentVerified) return true;
      return !this.subAgentAuth.token_mode;
    },
  },
  created() {
    this.getUserInfo();
    this.getSearchType();
    this.getAccountType();
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await getUserInfo(false);
        if (res && res.code === 200 && res.data) {
          this.isNew = res.data.is_new === 1;
        }
      } catch (e) {
        // 用户类型未确认时，保持隐藏新增授权入口。
        this.isNew = null;
      }
    },
    getFormItemValue(key) {
      const item = this.formData.find((x) => x.key === key);
      return item ? item.value : '';
    },
    async getSearchType() {
      const res = await getEnum({
        enum_type: 'status',
      });
      const options = formatMap(res.data) || [];
      let value = options[0].key;
      this.filterData = [
        {
          key: 'status',
          type: 'select',
          required: true,
          value,
          options,
          valueFormat: Number,
        },
        {
          key: 'keywords',
          placeholder: '支持应用ID/应用名称/账户ID搜索',
        },
      ];
      this.getList();
    },
    async getAccountType() {
      const res = await getEnum({
        enum_type: 'account_type',
      });
      const options = formatMap(res.data) || [];
      this.accountType = options;
    },
    async getList() {
      const res = await getAuthList(this.params);
      let data = res.data || {};
      let list = data.list || [];
      list.forEach((item) => {
        if (Number(item.status) === 2) {
          item.action = [
            {
              key: 'cancel',
              name: '取消授权',
            },
          ];
        } else {
          item.target_id_disabled = true;
        }
      });
      const pageInfo = res.data.page_info || {};
      this.$set(this.listData, 'currentPage', pageInfo.page || 0);
      this.$set(this.listData, 'total', pageInfo.total_number || 0);
      this.$set(this.listData, 'list', list);
    },
    async getAppList() {
      const res = await getAppList({});
      const list = res.data || [];
      const appOptions = formatMap(list, 'id', 'name');

      // 应用增加权限字段(scopes)
      appOptions.forEach((item) => {
        item.scopes = list.find((x) => x.id === item.key).scopes;
      });

      this.formData = [
        {
          key: 'app_id',
          name: '应用名称：',
          type: 'select',
          required: true,
          options: appOptions,
          valueFormat: Number,
        },
        {
          key: 'auth_type',
          name: '账号类型：',
          type: 'select',
          required: true,
          value: this.accountType[0].key,
          options: this.accountType,
          valueFormat: Number,
        },
        {
          key: 'auth_ids',
          name: '授权账号：',
          required: true,
          multiple: true,
          filterable: true,
          options: [],
          actions: [
            {
              key: 'add',
              name: '确认',
            },
          ],
        },
      ];
      this.formChange(this.formData[1]);
    },
    async getAccountList(params) {
      this.noAccountText = '';
      const res = await getAccountList(params);
      const list = res.data || [];
      if (params.account_id) {
        this.accounts = list;
      } else {
        this.accountList = list;
        this.$set(
          this.formData[2],
          'options',
          formatMap(list, 'account_id', 'display_name'),
        );
      }
      if (!list.length) {
        this.noAccountText = '无匹配账号';
      }
    },
    resetSubAgentAuth() {
      this.subAgentAuth = {
        sub_agent_id: '',
        token_mode: '',
        group_id: '',
        verifyStatus: '',
        verifyMessage: '',
        detail: {},
      };
      this.subAgentVerifyLoading = false;
    },
    resetSubAgentVerify() {
      this.subAgentAuth.verifyStatus = '';
      this.subAgentAuth.verifyMessage = '';
      this.subAgentAuth.detail = {};
      this.subAgentAuth.token_mode = '';
      this.subAgentAuth.group_id = '';
    },
    async verifySubAgent() {
      const appId = this.getFormItemValue('app_id');
      const subAgentId = String(this.subAgentAuth.sub_agent_id || '').trim();
      let message = '';

      if (!appId) {
        message = '请选择应用';
      }
      if (!message && !subAgentId) {
        message = '请输入授权账户';
      }
      if (message) {
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 3000,
        });
        return;
      }

      this.subAgentVerifyLoading = true;
      this.resetSubAgentVerify();
      try {
        const res = await verifySubAgentAuth({
          app_id: Number(appId),
          sub_agent_id: subAgentId,
        });
        const detail = (res && res.data) || {};
        if (res && res.code === 200 && detail.sub_agent_id) {
          this.subAgentAuth.detail = detail;
          this.subAgentAuth.verifyStatus = 'success';
        } else {
          this.subAgentAuth.verifyStatus = 'fail';
          this.subAgentAuth.verifyMessage = (res && res.message) || '';
        }
      } catch (e) {
        this.subAgentAuth.verifyStatus = 'fail';
        this.subAgentAuth.verifyMessage = (e && e.message) || '';
      } finally {
        this.subAgentVerifyLoading = false;
      }
    },
    setTokenMode(mode) {
      if (!this.isSubAgentVerified) return;
      this.subAgentAuth.token_mode = mode;
      this.onTokenModeChange(mode);
    },
    onTokenModeChange(mode) {
      if (Number(mode) !== TOKEN_MODE_REUSE) {
        this.subAgentAuth.group_id = '';
      }
    },
    getSubAgentValidateMessage(val) {
      if (!val.app_id) return '请选择应用';
      if (!this.subAgentAuth.sub_agent_id) return '请输入授权账户';
      if (!this.isSubAgentVerified) return '请先校验授权账户';
      if (!this.subAgentAuth.token_mode) return '请选择Token使用方式';
      if (
        Number(this.subAgentAuth.token_mode) === TOKEN_MODE_REUSE
        && !this.hasSelectedReuseGroup
      ) {
        return '请选择复用的Token';
      }
      return '';
    },
    getSubAgentApplyParams(val) {
      // 子管理账号授权只允许单个目标账号，提交参数在原 apply 接口上扩展。
      const params = {
        ...val,
        target_ids: [Number(this.subAgentVerifiedId)],
        token_mode: Number(this.subAgentAuth.token_mode),
      };

      // 仅子管理账号跨主体授权需要 token_mode；复用 Token 时才传 group_id。
      if (
        Number(this.subAgentAuth.token_mode) === TOKEN_MODE_REUSE
        && this.hasSelectedReuseGroup
      ) {
        params.group_id = Number(this.subAgentAuth.group_id);
      }
      return params;
    },
    async doApply() {
      let val = this.$refs.form.getValue();
      delete val.auth_ids;
      let message = '';
      let params = {};

      if (this.isSubAgentAuthType) {
        message = this.getSubAgentValidateMessage(val);
        if (!message) {
          params = this.getSubAgentApplyParams(val);
        }
      } else {
        let target_ids = [];
        this.accounts.forEach((item) => {
          target_ids.push(item.account_id);
        });
        if (!val.app_id) {
          message = '请选择应用';
        }
        if (!message && !target_ids.length) {
          message = '请添加授权账号';
        }
        if (!message) {
          params = {
            ...val,
            target_ids,
          };
        }
      }
      if (message) {
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 3000,
        });
        return;
      }
      const res = await applyAuth(params);
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.addDialogShow = false;
      this.params.page = 1;
      this.getList();
    },
    async doCancel() {
      const res = await cancelAuth({
        app_id: this.curItem.app_id,
        auth_type: this.curItem.auth_type,
        target_ids: [this.curItem.target_id],
      }).finally(() => {
        this.cancelDialogShow = false;
      });
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.getList();
    },
    changeHandle(item) {
      this.doSearch({
        ...this.params,
        [item.key]: item.value,
      });
    },
    doSearch(val) {
      this.params = {
        ...val,
        page: 1,
        page_size: this.params.page_size,
      };
      this.getList();
    },
    formChange(item) {
      if (item.key === 'app_id') {
        this.resetSubAgentAuth();
        this.accounts = [];
        this.noAccountText = '';
        // 清空账号类型选项
        let index = this.formData.findIndex((x) => x.key === 'auth_type');
        this.$set(this.formData[index], 'value', '');

        let opt = item.options.find((x) => x.key === item.value);
        // 应用权限包含agent、sub_agent，「账号类型」禁用广告主
        if (['agent', 'sub_agent'].some((x) => opt.scopes.includes(x))) {
          this.formData[index].options.forEach((x) => {
            if (['0'].includes(x.key)) {
              this.$set(x, 'disabled', true);
            }
          });
        } else {
          this.formData[index].options.forEach((x) => {
            this.$set(x, 'disabled', false);
          });
        }
      }

      if (item.key === 'auth_type') {
        let value = Number(item.value);
        this.accounts = [];
        this.noAccountText = '';
        if (value === 0) {
          this.resetSubAgentAuth();
          this.$delete(this.formData[2], 'type');
          this.$set(
            this.formData[2],
            'placeholder',
            '输入ADV广告主ID、多个ID用英文“，”分开',
          );
          this.$set(this.formData[2], 'value', '');
        } else if (value === SUB_AGENT_AUTH_TYPE) {
          // 子管理账号授权不适用原授权账户选择，改用 sub_agent_id 校验。
          this.resetSubAgentAuth();
          this.$set(this.formData[2], 'value', '');
        } else {
          this.resetSubAgentAuth();
          this.getAccountList({
            account_type: Number(item.value),
          });
          this.$set(this.formData[2], 'placeholder', '请选择授权账户');
          this.$set(this.formData[2], 'type', 'select');
          this.$set(this.formData[2], 'value', []);
        }
      }
    },
    actionClick(item, btn) {
      // 1000004,1000020,1000021,1000031,1000032,1000060,1000064,1500343,1652203,1725015,1725016,1725017,1725018,1725019
      let val = this.$refs.form.getValue();
      console.log('val>>>>', val);
      let authType = Number(val.auth_type);
      if (item.type === 'select') {
        let accounts = [];
        const value = item.value;
        this.accountList.forEach((a) => {
          if (value.indexOf(a.account_id) > -1) {
            accounts.push(a);
          }
        });
        this.accounts = accounts;
      } else {
        this.getAccountList({
          account_type: authType,
          account_id: item.value,
        });
      }
      const config = {
        0: {
          title: {
            key: 'user_name',
            label: '广告主账户名',
          },
          info: [
            {
              key: 'account_id',
              label: '广告主ID',
            },
            {
              key: 'display_name',
              label: '广告主名称',
            },
            {
              key: 'company',
              label: '广告主公司名',
            },
          ],
        },
        1: {
          title: {
            key: 'user_name',
            label: '代理商名称',
          },
          info: [
            {
              key: 'account_id',
              label: '代理商ID',
            },
            {
              key: 'display_name',
              label: '代理商账户名',
            },
            {
              key: 'company',
              label: '代理商公司名',
            },
          ],
        },
        6: {
          title: {
            key: 'user_name',
            label: '子管理名称',
          },
          info: [
            {
              key: 'account_id',
              label: '子管理ID',
            },
            {
              key: 'display_name',
              label: '子管理账户名',
            },
            {
              key: 'company',
              label: '子管理公司名',
            },
          ],
        },
        2: {
          title: {
            key: 'user_name',
            label: '管家用户名',
          },
          info: [
            {
              key: 'account_id',
              label: '管家账户ID',
            },
            {
              key: 'user_id',
              label: '管家用户ID',
            },
            {
              key: 'display_name',
              label: '管家公司名',
            },
          ],
        },
      };
      this.accountConfig = config[authType];
    },
    linkClickHandle(col, row) {
      const key = col.key;
      if (key === 'target_id') {
        this.curItem = row;
        this.secretShow = false;
        this.accessShow = false;
        this.refreshShow = false;
        this.infoDialogShow = true;
      } else if (key === 'verify_url') {
        this.$copyText(row[key]).then(
          (e) => {
            this.$message.success('已复制到粘贴板');
          },
          (e) => {
            this.$message.error('当前浏览器不支持复制');
          },
        );
      }
    },
    actionClickHandle(brn, row) {
      this.curItem = row;
      this.cancelDialogShow = true;
    },
    pageChangeHandle(page) {
      this.params.page = page;
      this.getList();
    },
    pageSizeChangeHandle(size) {
      this.params.page_size = size;
      this.params.page = 1;
      this.getList();
    },
    add() {
      if (this.isNew !== false) return;
      this.resetSubAgentAuth();
      this.getAppList();
      this.accounts = [];
      this.noAccountText = '';
      this.addDialogShow = true;
    },
    async doAdd() {
      // this.doApply();
      if (this.addSubmitLoading) return;

      this.addSubmitLoading = true;
      try {
        await this.doApply();
      } finally {
        this.addSubmitLoading = false;
      }
    },
    cancelAuth() {
      this.doCancel();
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-account-access {
  height: 100%;
  padding: 40px 74px;
  box-sizing: border-box;
  overflow-y: auto;
  .title-page {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    .text-title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
    .item-btn {
      width: 130px;
      height: 40px;
      line-height: 40px;
      background: $primary-color;
      box-shadow: 0px 2px 4px 0px rgba(0, 94, 181, 0.19);
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-family: NotoSansHans-Bold, NotoSansHans;
      font-weight: bold;
      color: #fff;
    }
  }
  .dialog-right {
    .add-content-box {
      padding: 14px 10px;
      .sub-agent-auth-box {
        .sub-agent-form-row {
          display: flex;
          margin-bottom: 14px;
          .sub-agent-label {
            flex-shrink: 0;
            display: inline-block;
            width: 130px;
            height: 40px;
            padding-right: 0;
            box-sizing: border-box;
            text-align: right;
            line-height: 40px;
            font-size: 14px;
            color: #606266;
            &.is-required {
              &:before {
                content: '*';
                margin-right: 4px;
                color: #f56c6c;
              }
            }
          }
          .sub-agent-field,
          .token-mode-field {
            width: 460px;
          }
          .sub-agent-check-row {
            display: flex;
            .el-input {
              flex: 1;
            }
            .el-button {
              margin-left: 10px;
            }
          }
          .sub-agent-verify-info {
            margin-top: 10px;
            line-height: 22px;
            .sub-agent-name {
              margin-bottom: 4px;
              font-size: 14px;
              font-weight: 500;
              color: #606266;
            }
            .sub-agent-status-row {
              display: flex;
              align-items: center;
              .sub-agent-status-tag {
                display: inline-block;
                height: 20px;
                padding: 0 8px;
                border: 1px solid;
                border-radius: 10px;
                box-sizing: border-box;
                line-height: 18px;
                font-size: 12px;
                &.success {
                  border-color: #d9ecff;
                  background: #ecf5ff;
                  color: $primary-color;
                }
                &.fail {
                  border-color: #fde2e2;
                  background: #fef0f0;
                  color: #f56c6c;
                }
              }
              .sub-agent-budget-tip {
                margin-left: 10px;
                font-size: 12px;
                color: #909399;
              }
              .sub-agent-fail-tip {
                margin-left: 10px;
                font-size: 12px;
                color: #c45656;
              }
            }
          }
          .token-mode-group {
            display: block;
            width: 100%;
            .token-mode-option {
              display: flex;
              align-items: flex-start;
              min-height: 68px;
              margin-bottom: 10px;
              padding: 12px;
              box-sizing: border-box;
              border: 1px solid #dcdfe6;
              border-radius: 6px;
              cursor: pointer;
              &.active {
                border-color: $primary-color;
              }
              &.disabled {
                cursor: not-allowed;
                .token-mode-title,
                .token-mode-desc {
                  color: #c0c4cc;
                }
              }
              .el-radio {
                flex-shrink: 0;
                margin-top: 1px;
                margin-right: 8px;
              }
              .token-mode-content {
                flex: 1;
                min-width: 0;
              }
              .token-mode-title {
                margin-bottom: 6px;
                font-size: 14px;
                line-height: 18px;
                color: #303133;
              }
              .token-mode-desc {
                font-size: 12px;
                line-height: 18px;
                color: #909399;
              }
            }
          }
          .reuse-token-row {
            margin-top: 12px;
            cursor: default;
            .reuse-token-label {
              display: block;
              margin-bottom: 6px;
              font-size: 14px;
              line-height: 20px;
              color: #606266;
            }
            .reuse-token-select {
              width: 100%;
            }
          }
        }
      }
      .account-box {
        display: flex;
        .form-label {
          display: inline-block;
          width: 130px;
          height: 40px;
          text-align: right;
          line-height: 40px;
        }
        .no-account-text {
          height: 40px;
          line-height: 40px;
          color: #f56c6c;
        }
        .account-items {
          .account-item {
            margin-bottom: 10px;
            width: 460px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            line-height: 40px;
            .account-title {
              padding: 0 15px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-size: 14px;
              font-weight: 500;
              color: #606266;
              background: #fafafa;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border-bottom: 1px solid #dcdfe6;
            }
            .account-info {
              padding: 0 15px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #606266;
            }
          }
        }
      }
    }
    .app-items {
      padding: 0 22px;
      .app-item {
        display: flex;
        align-items: flex-start;
        padding: 11px 0;
        border-bottom: 1px solid #f2f2f2;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        .app-label {
          flex-shrink: 0;
          display: inline-block;
          width: 110px;
          color: #666666;
          .app-label-tip {
            padding-top: 6px;
            font-size: 12px;
            font-weight: bolder;
            .active {
              color: $primary-color;
            }
          }
        }
        .app-value {
          flex-grow: 1;
          color: #333333;
        }
        .btn-item {
          flex-shrink: 0;
          margin-left: 13px;
          font-size: 12px;
          font-weight: 500;
          color: $primary-color;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .dialog-confirm {
    .confirm-content {
      padding-top: 107px;
      padding-bottom: 30px;
      background-image: url('~@/assets/image/icon_alert.png');
      background-size: 72px;
      background-position: center 15px;
      background-repeat: no-repeat;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
</style>
